module.exports = __webpack_public_path__ + "static/media/visa_white.2b9e533e.png";